module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch10"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AMES")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ROWN")])])])]), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/footnote#footnote10",
      "id": "fn10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EATLES WERE ONE-OF-A-KIND AND A BLESSING TO THE MUSIC WORLD, EACH AND EVERY ONE OF THEM.")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHN WAS EXTREMELY TALENTED—HE SEEMED TO HAVE A LOT ON HIS MIND, BUT IT NEVER HURT HIS MUSIC, SO")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CAN TRULY")]), _vm._v(" say: I think there will never be another like that beautiful brother, may God bless his soul and his family. John, we will never forget you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117bf5ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch10.vue
// module id = 99
// module chunks = 0